import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren  } from '@angular/core';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit, AfterViewInit {
  @ViewChildren('input') vc;

  constructor() { }

  @Input() x = 0;
  @Input() y = 0;
  @Input() acceptText = '';
  @Input() cancelText = '';
  @Input() title: string;
  @Input() textRows: string[] = [];
  @Output() buttonEvent = new EventEmitter<string>();

  ngOnInit() {
  }

  ngAfterViewInit() {
      setTimeout(() => { this.vc.first.nativeElement.focus(); });
  }

  acceptClicked() {
      this.buttonEvent.emit('Accept');
  }

  cancelClicked() {
      this.buttonEvent.emit('Cancel');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirmation-dialog/confirmation-dialog.component.ts